import { useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from './client.js';
import type { TenantKpis } from './types.js';

export function useDashboardKpis(tenantId: string) {
  return useQuery<TenantKpis>({
    queryKey: ['dashboard-kpis', tenantId],
    queryFn: () => apiFetch<TenantKpis>(`/dashboard/kpis?tenantId=${encodeURIComponent(tenantId)}`),
    enabled: Boolean(tenantId),
    staleTime: 60_000,
  });
}

export function useRefreshDashboardKpis() {
  const qc = useQueryClient();
  return (tenantId: string) => {
    void qc.invalidateQueries({ queryKey: ['dashboard-kpis', tenantId] });
  };
}
